import { Button, Col, Row, Switch, Typography } from "antd"
import { observer } from "mobx-react"
import { useTranslation } from "react-i18next"
import { DragDropContext, Droppable, Draggable, DropResult } from "react-beautiful-dnd"
import { BannerForm } from "../entities/BannerForm"
import { BannersFormViewModel } from "../BannersFormViewModel"
import BannerSelection from "./BannerSelection"

const { Title } = Typography

interface BannerImagesFormProps {
	main: boolean
	viewModel: BannersFormViewModel
	onBannerChange?: (banners: BannerForm[]) => void
}

const BannerImagesForm = ({ main, viewModel, onBannerChange }: BannerImagesFormProps) => {
	const { t } = useTranslation("banners")
	const addBanner = () => {
		const position = viewModel.getBanners(main ? "mainBanner" : "secondaryBanner").length + 1
		viewModel.addBanner(
			new BannerForm({
				weight: position,
				type: main ? "mainBanner" : "secondaryBanner",
				language: viewModel.selectedLanguage,
				key: viewModel.microsite
			})
		)
		onBannerChange && onBannerChange(viewModel.banners)
	}
	const dragBanner = (result: DropResult) => {
		if (!result.destination) return
		viewModel.reorderBanners(
			main ? "mainBanner" : "secondaryBanner",
			result.source.index,
			result.destination?.index
		)
		onBannerChange && onBannerChange(viewModel.banners)
	}
	return (
		<Row style={{ margin: 0, padding: 20 }}>
			<Col xl={24} md={24} xs={24}>
				<Row>
					<Title
						style={{ marginTop: 0, textDecoration: "underline", marginRight: 10, marginLeft: 10 }}
						level={5}
					>
						{main ? t("mainBanners") : t("secondaryBanners")}
					</Title>
				</Row>
				{viewModel.banners && viewModel.selectedLanguage && (
					<DragDropContext onDragEnd={dragBanner}>
						<Droppable droppableId={`${viewModel.microsite}-${main ? "main" : "secondary"}`}>
							{(provided, snapshot) => (
								<div {...provided.droppableProps} ref={provided.innerRef}>
									{viewModel
										.getBanners(main ? "mainBanner" : "secondaryBanner", !main)
										.map((banner, index) => (
											<Draggable key={banner.viewId} draggableId={banner.viewId} index={index}>
												{(provided, snapshot) => (
													<div
														ref={provided.innerRef}
														{...provided.draggableProps}
														{...provided.dragHandleProps}
													>
														<BannerSelection
															banner={banner}
															canDelete={main && banner.weight > 1}
															isSecondary={!main}
															onChange={(image, imageType) => {
																viewModel.loadNewBannerImage(
																	banner.viewId,
																	image,
																	imageType
																)
																onBannerChange && onBannerChange(viewModel.banners)
															}}
															onClean={imageType => {
																viewModel.removeNewBannerImage(banner.viewId, imageType)
																onBannerChange && onBannerChange(viewModel.banners)
															}}
															onDelete={() => {
																viewModel.removeBanner(banner)
																onBannerChange && onBannerChange(viewModel.banners)
															}}
															onHrefChange={href => {
																viewModel.setBannerHref(banner.viewId, href)
																onBannerChange && onBannerChange(viewModel.banners)
															}}
															onToggleEnabled={(enabled: boolean) => {
																viewModel.toggleBannerEnabled(banner.viewId, enabled)
																onBannerChange && onBannerChange(viewModel.banners)
															}}
														/>
													</div>
												)}
											</Draggable>
										))}
									{provided.placeholder}
								</div>
							)}
						</Droppable>
					</DragDropContext>
				)}
			</Col>
		</Row>
	)
}
export default observer(BannerImagesForm)
